<div [formGroup]="projectTypeForm" *ngIf="projectTypeForm" class="whole-modal">
    <div class="modal-header position-relative">
        <div class="row w-100 mt-3">
            <div class="col-lg-4" *ngIf="modalMode === 'add'">
                <div class="d-flex align-items-center h-100">
                    <h4>Create Project Type</h4>
                </div>
            </div>
            <div class="col">
                <div class="d-flex justify-content-end align-items-center h-100">
                    <h3 class="activity_title d-flex overflow-hidden text-nowrap align-items-center m-0">
                        Instance Name
                        <span data-bs-toggle="tooltip" data-bs-placement="top" title="{{ currentInstanceName }}" class="text-truncate">{{
                            currentInstanceName
                        }}</span>
                        Asset Type
                        <span class="text-truncate" data-bs-toggle="tooltip" data-bs-placement="top" title="{{ currentAssetType }}">{{
                            currentAssetType
                        }}</span>
                        <div *ngIf="modalMode === 'edit'">
                            Project Type<span class="text-truncate" data-bs-toggle="tooltip" data-bs-placement="top">{{ projectType?.name }}</span>
                        </div>
                    </h3>
                    <a class="" href="javascript:void()" (click)="closeModalWithCancel()" ngbAutofocus><i  style="margin-top:17px;" class="flaticon2-cross close-icon position-absolute"></i></a>
                </div>
            </div>
           
        </div>
    </div>
    <div class="modal-body output-lable">
        <div class="row">
            <div class="col-md-12">
                <div class="activity_details">
                    <div class="row mb-3 mt-3">
                        <div class="col-md-12">
                            <div class="d-flex align-items-center mb-3">
                                <h3 class="mb-0 title-wrap"><span>Name</span></h3>
                                <div class="w-100">
                                    <mat-form-field class="example-full-width exmple-name-field custom-text-field" [floatLabel]="'never'">
                                        <input
                                            type="text"
                                            formControlName="name"
                                            matInput
                                            placeholder="Name"
                                            (keypress)="onKeyPress($event)"
                                            (paste)="onKeyPress($event)"
                                        />
                                    </mat-form-field>
                                    <span class="text-danger" *ngIf="projectTypeForm.get('name')?.errors?.duplicateName == true"
                                        >Project name is already exists!</span
                                    >
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="d-flex align-items-center">
                                <h3 class="mb-0 title-wrap"><span>Description</span></h3>
                                <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                                    <input
                                        type="text"
                                        formControlName="description"
                                        matInput
                                        placeholder="Description"
                                        name="instance_name"
                                        (keypress)="onKeyPress($event)"
                                        (paste)="onKeyPress($event)"
                                    />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div class="schema_defination">
                    <h4>Latest Schema Definition</h4>
                    <button
                        class="btn primary-ebtn"
                        (click)="addNewVersion()"
                        #tooltip="matTooltip"
                        [disabled]="projectType?.schemaVersions?.length == 20 || isVersionAdd"
                        matTooltip="Add New Schema"
                    >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let schema of displayVersionList; let i = index">
                            <mat-expansion-panel-header>
                                <mat-panel-title style="width: 100%">
                                    Version {{ schema.version }}<span *ngIf="schema.schemaVersionId == null" class="text-danger">*</span>
                                </mat-panel-title>
                                <mat-panel-description>
                                    <!-- <mat-icon><a href="javascript:void(0)">insert_drive_file</a></mat-icon>
                      <mat-icon><a href="javascript:void(0)">clear</a></mat-icon> -->
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="json-editor">
                                <json-editor #editor [options]="getJsonEditorOptions(schema)" [data]="getSchemaData(schema.schemaVersionId)"></json-editor>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <mat-paginator
                        [length]="currentPageItemLength"
                        *ngIf="projectTypeVersionList.length > 4"
                        [pageSize]="pageSize"
                        (page)="pageEvent = getPaginationData($event)"
                        #paginator
                    >
                    </mat-paginator>
                </div>
            </div>
            <div class="col-md-12 mt-3 mb-3">
                <div class="card card-custom card-shadow">
                    <div class="card_gridTwo">
                        <!-- <div class="d-flex justify-content-between align-items-center">
              <div class="card-status">
                <h4>Activity Pack Status</h4>
              </div>
              <div>
                <button class="btn primary-ebtn" #tooltip="matTooltip" matTooltip="Add New Status" (click)="addNewActivityPackStatus()"
                [matTooltipPosition]="tooltip_position">
                <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
              </div>
            </div> -->
                        <!-- <div class="activity-pack-status-table">
              <div *ngIf="modalMode==='edit'">
                <app-instance-activity-pack-status (newStatusColor)="updateStatusColor($event)"
                  [activityPackTypeStatusList]="activityPackType.activityPackTypeStatuses"></app-instance-activity-pack-status>
              </div>
              <div *ngIf="modalMode==='add'">
                <app-instance-activity-pack-status (newStatusColor)="updateStatusColor($event)"
                  [activityPackTypeStatusList]="defaultActivityPackStatusList"></app-instance-activity-pack-status>
              </div>
            </div> -->
                        <app-instance-project-type-status
                            [projectTypeStatusTypeList]="defaultProjectStatusTypes"
                            [currentProjectType]="projectType"
                        ></app-instance-project-type-status>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <!-- <button type="button" class="btn primary-ebtn me-3" (click)="open1(activity_modal)">Create
    Activity
    Pack Status</button> -->
        <button href="javascript:void()" type="button" (click)="closeModalWithCancel()" class="btn secondary-ebtn me-3">Cancel</button>
        <button type="button" class="btn primary-ebtn" [disabled]="checkDisable()" (click)="saveActivityPackType()">Save</button>
    </div>
</div>
